import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router";
import { Helmet } from "react-helmet";

import handleApiError from "../helpers/handleApiError";

import ClaimTable from "./ClaimTable";
import { getClaims, getExportedClaims } from "../services/claimService";
import { defaultTitle } from "../config";

import ExcelExportDataAction from "./ExcelExportDataAction";

const ClaimBoard = () => {
  const history = useHistory();

  const {
    data: claims,
    mutate,
    isLoading,
    isError,
  } = useMutation({
    mutationFn: () => getClaims(),
    mutationKey: ["claims"],
    onError: (error) => handleApiError(error, history),
  });

  const handleDetailsClick = (claimId) => {
    history.push(`/claim/${claimId}`);
  };

  useEffect(() => {
    mutate();
  }, [mutate]);

  return (
    <>
      <Helmet>
        <title>Claims - {defaultTitle}</title>
      </Helmet>
      <div
        className="heading-containter center-flex-container tw-relative"
        style={{ flexDirection: "column" }}
      >
        <h1 className="claims-title">Claims</h1>

        <div className="tw-absolute tw-right-0 tw-top-0">
          <ExcelExportDataAction
            className="export-button"
            alt="Export claims"
            title="Export Claims"
            fileName="Diligent Claims"
            getExportData={getExportedClaims}
          />
        </div>
      </div>
      <br />
      <ClaimTable
        claims={claims?.data || []}
        onDetailsClick={handleDetailsClick}
        isLoading={isLoading}
        isError={isError}
      />
    </>
  );
};

export default ClaimBoard;
